import constants from '../constants/actions';
import APP from 'app';
const { Utils } = APP,
    { getTotalValues } = Utils;


const initialState = {
    confirmJson: {},
    paymentValidated: false,
    confirmError: '',
    sendingWhatsapp: false,
    fetchingTcsRepricing: false,
    specialRequestResponse: {},
    fetchingSpecialRequest: false
};

export default function thankyou(state = initialState, action) {
    try {
        const { type = '', payload = {} } = action;
        switch (type) {
            case constants.THANKYOU.GET_DATA: {
                const { bookingStatus = {}, errors = [] } = payload,
                    { success } = bookingStatus,
                    [firstErr = {}] = errors,
                    { message = '' } = firstErr;
                return {
                    ...state,
                    confirmJson: payload,
                    confirmError: !success ? message : ''
                };
            }

            case constants.THANKYOU.PAYMENT_VALIDATION: {
                const { status = {} } = payload,
                    { success = false } = status;

                return {
                    ...state,
                    paymentValidated: success
                };
            }

            case constants.THANKYOU.EMPTY_VALIDATE_PAYMENT: {
                return {
                    ...state,
                    paymentValidated: payload
                };
            }

            case constants.THANKYOU.EMPTY_CONFIRM_JSON: {
                return {
                    ...state,
                    confirmJson: payload
                };
            }
            case constants.THANKYOU.UPDATE_CONFIRM_JSON: {
                return {
                    ...state,
                    confirmJson: payload
                };
            }
            case constants.THANKYOU.SENDING_WHATSAPP: {
                return {
                    ...state,
                    sendingWhatsapp: true
                };
            }
            case constants.THANKYOU.SEND_WHATSAPP: {
                return {
                    ...state,
                    sendingWhatsapp: false
                };
            }
            case constants.THANKYOU.FETCHING_TCSCONFIRMDATA: {
                return {
                    ...state,
                    confirmJson: {
                        ...state.confirmJson,
                        fetchingTcsRepricing: true
                    }

                }
            };

            case constants.THANKYOU.GET_TCSCONFIRMDATA: {
                const { rti = [], hi = {}, roomLevelEdArray = [], bookingLevelEd = "" } = payload;
                const { ops = [], ss = [] } = hi
                const [firstObj = {}] = ops,
                    { omi = {} } = firstObj,
                    { ispfar = false } = omi;
                const { ris = [] } = firstObj;
                return {
                    ...state,
                    confirmJson: {
                        ...state.confirmJson,
                        storeJson: rti,
                        ispfar: ispfar,
                        bookingLevelEd,
                        roomLevelEdArray,
                        totalValues: getTotalValues(ris, ss, omi),
                        tcsRepricingData: payload,
                        samePanPerBooking: ispfar,
                        fetchingTcsRepricing: false
                    },

                };
            };
            case constants.THANKYOU.FETCHING_SPECIALRESPONSE: {
                return {
                    ...state,
                    fetchingSpecialRequest: true
                };
            };

            case constants.THANKYOU.GET_SPECIALREQUESTRESPONSE: {
                return {
                    ...state,
                    fetchingSpecialRequest: false,
                    specialRequestResponse: payload
                };
            }

            default:
                return state;
        }

    } catch (error) {
        console.log('Thankyou Try catch Error ', error);
        return state;
    }
}
